import type { ServiceResponse } from './types';
import { apiRequest } from '../utils/api';
import { API_ENDPOINTS } from '../config/api.config';

export interface PaymentExtractionData {
  amount: number;
  transactionId?: string;
  paymentMethod?: string;
  date?: string;
  payer?: string;
  receiver?: string;
  status?: string;
  confidence: number;
  rawText?: string;
}

export interface ExtractPaymentRequest {
  imageData: string;
  mimeType: string;
}

class PaymentExtractionService {
  // Extract payment information from image using AI
  async extractPaymentInfo(request: ExtractPaymentRequest): Promise<ServiceResponse<PaymentExtractionData>> {
    try {
      console.log('🔌 PaymentExtractionService: Making API call to', API_ENDPOINTS.PAYMENT_EXTRACTION.EXTRACT);
      const response = await apiRequest<PaymentExtractionData>(
        API_ENDPOINTS.PAYMENT_EXTRACTION.EXTRACT,
        {
          method: 'POST',
          body: JSON.stringify(request),
        },
        true
      );

      console.log('📡 PaymentExtractionService: API response received', response);
      return {
        success: true,
        data: response
      };
    } catch (error) {
      console.error('💥 PaymentExtractionService: Error extracting payment info:', error);
      return {
        success: false,
        data: null as any,
        error: error instanceof Error ? error.message : 'Failed to extract payment information'
      };
    }
  }

  // Validate payment total against order total
  async validatePaymentTotal(
    payments: PaymentExtractionData[],
    orderTotal: number
  ): Promise<ServiceResponse<{
    isValid: boolean;
    totalExtracted: number;
    difference: number;
    message: string;
  }>> {
    try {
      const response = await apiRequest<{
        isValid: boolean;
        totalExtracted: number;
        difference: number;
        message: string;
      }>(
        API_ENDPOINTS.PAYMENT_EXTRACTION.VALIDATE_TOTAL,
        {
          method: 'POST',
          body: JSON.stringify({
            payments,
            orderTotal
          }),
        },
        true
      );

      return {
        success: true,
        data: response
      };
    } catch (error) {
      console.error('Error validating payment total:', error);
      return {
        success: false,
        data: {
          isValid: false,
          totalExtracted: 0,
          difference: orderTotal,
          message: 'Failed to validate payment total'
        },
        error: error instanceof Error ? error.message : 'Failed to validate payment total'
      };
    }
  }
}

export const paymentExtractionService = new PaymentExtractionService();